const namespace = 'CATEGORIES';

export const REQUEST_CATEGORIES = `${namespace}/REQUEST_CATEGORIES`;
export const RECEIVE_CATEGORIES_SUCCESS = `${namespace}/RECEIVE_CATEGORIES_SUCCESS`;
export const RECEIVE_CATEGORIES_FAILURE = `${namespace}/RECEIVE_CATEGORIES_FAILURE`;
